import { render, staticRenderFns } from "./pointTpl.vue?vue&type=template&id=2e8d8832&scoped=true"
import script from "./pointTpl.vue?vue&type=script&lang=js"
export * from "./pointTpl.vue?vue&type=script&lang=js"
import style0 from "./pointTpl.vue?vue&type=style&index=0&id=2e8d8832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d8832",
  null
  
)

export default component.exports